import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ROLES = ["Developer / Project Owner", "Investor / Asset Owner", "EPC / Construction", "International Company", "Other"];
const EMPTY = { name: "", company: "", role: "", email: "", phone: "", message: "", website: "" };

const validate = (f) => {
  const e = {};
  if (!f.name.trim()) e.name = "Please enter your name";
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email.trim())) e.email = "Please enter a valid email";
  if (!f.message.trim()) e.message = "Please enter a message";
  return e;
};

const Field = ({ id, label, error, children }) => (
  <div className="mb-5">
    <label htmlFor={`contact-${id}`} className="sr-only">{label}</label>
    {children}
    {error && <p className="field-error" data-testid={`contact-${id}-error`}>{error}</p>}
  </div>
);

export const ContactForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const errs = validate(form);
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setStatus("sending");
    try {
      await axios.post(`${API}/inquiries`, form);
      setStatus("sent");
      setForm(EMPTY);
    } catch {
      setStatus("error");
    }
  };

  if (status === "sent") {
    return (
      <div className="border-l-2 border-white pl-6" data-testid="contact-success-message">
        <p className="text-[20px] font-medium text-white">Thank you for contacting Arka Likas Solutions.</p>
        <p className="mt-3 text-[15px] leading-[1.7] text-white/75">Your message has been sent to our team at biz@arkalikas.com. We will be in touch shortly.</p>
      </div>
    );
  }

  const input = (id, label, type = "text") => (
    <Field id={id} label={label} error={errors[id]}>
      <input id={`contact-${id}`} type={type} placeholder={label} className="dark-field" value={form[id]} onChange={set(id)} aria-invalid={!!errors[id]} data-testid={`contact-${id}-input`} />
    </Field>
  );

  return (
    <form noValidate className="relative" onSubmit={submit} data-testid="contact-form">
      {input("name", "Name")}
      {input("company", "Company")}
      <Field id="role" label="I am a">
        <select id="contact-role" className={`dark-field dark-select ${form.role ? "" : "is-placeholder"}`} value={form.role} onChange={set("role")} data-testid="contact-role-select">
          <option value="">I am a</option>
          {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
      </Field>
      {input("email", "Email", "email")}
      {input("phone", "Phone", "tel")}
      <Field id="message" label="Message" error={errors.message}>
        <textarea id="contact-message" rows={4} placeholder="Message" className="dark-field resize-none" value={form.message} onChange={set("message")} aria-invalid={!!errors.message} data-testid="contact-message-input" />
      </Field>
      <div className="absolute -left-[9999px] top-auto h-px w-px overflow-hidden" aria-hidden="true">
        <label htmlFor="contact-website">Website</label>
        <input id="contact-website" tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} data-testid="contact-website-honeypot" />
      </div>
      {status === "error" && <p className="field-error mb-4" data-testid="contact-submit-error">Something went wrong. Please try again or email biz@arkalikas.com.</p>}
      <button type="submit" className="btn-submit-light mt-2" disabled={status === "sending"} data-testid="contact-submit-button">
        {status === "sending" ? "Sending…" : "Discuss a Project"}
      </button>
    </form>
  );
};
